import { render, staticRenderFns } from "./ListBlackouts.vue?vue&type=template&id=3b4ac3a8&"
import script from "./ListBlackouts.vue?vue&type=script&lang=js&"
export * from "./ListBlackouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports